import React from 'react';
import styled from 'styled-components';
import { keys } from 'lodash';

const AlertsLevelFraudComponent = ({ actionCount, actionList }) => {
  return (
    <StyledDiv>
      {keys(actionCount).map((key) => {
        const actionType = actionList.find(
          ({ displayName }) => displayName?.toLowerCase() === key?.toLowerCase()
        );

        return (
          <div
            key={key}
            className={`${actionType?.alertLevel?.toLowerCase()}-level`}>
            {key}: {actionCount[key]}
          </div>
        );
      })}
    </StyledDiv>
  );
};

const StyledDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 11px;
  font-weight: 500;
  flex-wrap: wrap;
  margin-bottom: -8px;

  div {
    margin-right: 12px;
    margin-bottom: 8px;
  }

  .high-level {
    color: #e94e43;
  }

  .good-level {
    color: #eb922a;
  }

  .low-level {
    color: #49c93d;
  }
`;

export default AlertsLevelFraudComponent;
